import { motion } from "motion/react";
import { Zap, Workflow, Clock, Shield } from "lucide-react";
import { metrics } from "../lib/landingData";
import { HolographicCard } from "../components/HolographicCard";

const iconMap = {
  "< 100ms": Zap,
  Zero: Workflow,
  "24/7": Clock,
  "SOC 2": Shield,
} as const;

export function MetricSection() {
  return (
    <section id="platform" className="py-32 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[700px] w-[700px] bg-purple-500/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-foreground mb-4">
            Built for speed and scale
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Infrastructure that stays out of your way so your team can focus on outcomes.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {metrics.map((metric, index) => {
            const Icon = iconMap[metric.value as keyof typeof iconMap] ?? Zap;
            return (
              <motion.div
                key={metric.label}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <HolographicCard interactive className="h-full">
                  <Icon className="h-8 w-8 text-primary mb-4" />
                  <div className="text-3xl font-black tracking-tight text-foreground mb-1">
                    {metric.value}
                  </div>
                  <div className="text-sm font-medium text-muted-foreground mb-2">
                    {metric.label}
                  </div>
                  <p className="text-sm text-muted-foreground">{metric.description}</p>
                </HolographicCard>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
